'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThListOutline = function TiThListOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 30c0.9 0 1.6 0.8 1.6 1.7s-0.7 1.6-1.6 1.6h-11.7c-0.9 0-1.7-0.7-1.7-1.6s0.8-1.7 1.7-1.7h11.7z m0-3.3h-11.7c-2.8 0-5 2.2-5 5s2.2 5 5 5h11.7c2.7 0 5-2.3 5-5s-2.3-5-5-5z m0-8.4c0.9 0 1.6 0.8 1.6 1.7s-0.7 1.7-1.6 1.7h-11.7c-0.9 0-1.7-0.8-1.7-1.7s0.8-1.7 1.7-1.7h11.7z m0-3.3h-11.7c-2.8 0-5 2.2-5 5s2.2 5 5 5h11.7c2.7 0 5-2.2 5-5s-2.3-5-5-5z m0-8.3c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7h-11.7c-0.9 0-1.7-0.7-1.7-1.7s0.8-1.6 1.7-1.6h11.7z m0-3.4h-11.7c-2.8 0-5 2.3-5 5s2.2 5 5 5h11.7c2.7 0 5-2.2 5-5s-2.3-5-5-5z m-21.7 23.4h-3.3c-1.9 0-3.4 1.5-3.4 3.3v3.3c0 1.9 1.5 3.4 3.4 3.4h3.3c1.8 0 3.3-1.5 3.3-3.4v-3.3c0-1.8-1.5-3.3-3.3-3.3z m0 6.6h-3.3v-3.3h3.3v3.3z m0-18.3h-3.3c-1.9 0-3.4 1.5-3.4 3.3v3.4c0 1.8 1.5 3.3 3.4 3.3h3.3c1.8 0 3.3-1.5 3.3-3.3v-3.4c0-1.8-1.5-3.3-3.3-3.3z m0 6.7h-3.3v-3.4h3.3v3.4z m0-18.4h-3.3c-1.9 0-3.4 1.5-3.4 3.4v3.3c0 1.8 1.5 3.3 3.4 3.3h3.3c1.8 0 3.3-1.5 3.3-3.3v-3.3c0-1.9-1.5-3.4-3.3-3.4z m0 6.7h-3.3v-3.3h3.3v3.3z' })
        )
    );
};

exports.default = TiThListOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-list-outline.js
// module id = 3994
// module chunks = 0